import React from "react";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import withIntl from "../../../utils/withIntl";
import { DialogActions, IconButton, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { Modifiergroup } from "../../../store/articles/models/Modifiergroup";
import { useDialog } from "../../Dialogs/DialogProvider";
import { makeStyles } from "@material-ui/core/styles";
import LinkedItems from "../LinkedItems";
import articlesStore from "../../../store/articles/ArticlesStore";
import EditTextField from "../../EditArticle/EditTextField";
import Button from "@material-ui/core/Button";
import { createModifiergroups } from "../../../store/articles/ModifiergroupsApi";
import EditSwitch from "../../EditArticle/EditSwitch";
import EditNumberField from "../../EditArticle/EditNumberField";

const useStyles = makeStyles(() => ({}));

function NewModifiergroupDialog(props) {
  const classes = useStyles();
  const filteredPlus = [];
  Object.keys(articlesStore.modifiergroups).forEach((key) => {
    if (!isNaN(articlesStore.modifiergroups[key].plu)) filteredPlus.push(articlesStore.modifiergroups[key].plu);
  });
  const newModifiergroup = new Modifiergroup(
    undefined,
    undefined,
    false,
    "",
    false,
    false,
    Math.min(
      0,
      ...Object.keys(articlesStore.modifiergroups).map(
        (modifiergroupIds) => articlesStore.modifiergroups[modifiergroupIds].priority
      )
    ) - 1,
    Math.max(0, ...filteredPlus) + 1,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    [props.article.id],
    undefined
  );
  const [modifiergroup] = React.useState({ ...newModifiergroup });
  const [, closeDialog] = useDialog();

  let linkedArticles = [];
  linkedArticles.push({
    name: articlesStore.articles[props.article.id].name,
  });

  const handleAddModifiergroup = (value) => {
    createModifiergroups(articlesStore.merchantId, [modifiergroup]);
  };

  return (
    <>
      <DialogTitle id="form-dialog-title">
        <div style={{ display: "flex" }}>
          <Typography variant={"h5"}>{props.intl.formatMessage({ id: "create_new_option_group" })}</Typography>
        </div>
        <IconButton
          onClick={() => {
            closeDialog();
          }}
          color="primary"
          style={{ position: "absolute", top: "8px", right: "8px" }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent classes={{ root: classes.rootDialog }}>
        <div style={{ height: "auto", alignItems: "center", marginBottom: 20 }}>
          <EditTextField
            authorizationField={"modifiergroup.name"}
            label={props.intl.formatMessage({ id: "option_group_name" })}
            value={modifiergroup.name != null ? modifiergroup.name : ""}
            onBlur={(value) => {
              modifiergroup.name = value;
            }}
            variant={"standard"}
          />
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ width: "50%" }}>
            <EditTextField
              authorizationField={"modifiergroup.pos_name"}
              label={props.intl.formatMessage({ id: "batch.pos_name" })}
              value={modifiergroup.pos_name != null ? modifiergroup.pos_name : ""}
              onBlur={(value) => {
                modifiergroup.pos_name = value;
              }}
              variant={"standard"}
            />
          </div>
          <div style={{ paddingLeft: 3, width: "50%" }}>
            <EditNumberField
              variant={"standard"}
              authorizationField={"modifiergroup.max_n"}
              label={"Max N"}
              value={modifiergroup.max_n == null ? "" : modifiergroup.max_n}
              onBlur={(value) => (modifiergroup.max_n = value)}
            />
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <EditSwitch
            label={props.intl.formatMessage({ id: "multiple" })}
            key={modifiergroup.key}
            authorizationField={"modifiergroup.multiple"}
            value={modifiergroup.multiple}
            onChange={(newValue) => (modifiergroup.multiple = newValue)}
          />
          <EditSwitch
            label={props.intl.formatMessage({ id: "optional" })}
            key={modifiergroup.key}
            authorizationField={"modifiergroup.optional"}
            value={modifiergroup.optional}
            onChange={(newValue) => (modifiergroup.optional = newValue)}
          />
          <EditSwitch
            label={props.intl.formatMessage({ id: "numerable" })}
            key={modifiergroup.key}
            authorizationField={"modifiergroup.numerable"}
            value={modifiergroup.numerable}
            onChange={(newValue) => (modifiergroup.numerable = newValue)}
          />
        </div>
        <LinkedItems
          title={props.intl.formatMessage({ id: "linked_articles" })}
          disabledButtons={true}
          linkedItems={linkedArticles}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleAddModifiergroup();
            closeDialog();
          }}
        >
          {props.intl.formatMessage({ id: "add" })}
        </Button>
      </DialogActions>
    </>
  );
}

export default withIntl(NewModifiergroupDialog);
